import * as React from 'react'

import MuiLoadingButton from '@mui/lab/LoadingButton'
import MuiButton, { ButtonProps } from '@mui/material/Button'
import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton'

import { useHistory, useSelector } from 'domains/application/hooks'

import { type HistoryLinkProps } from 'lib/Link'

type Props = ButtonProps & HistoryLinkProps
type IconProps = IconButtonProps & HistoryLinkProps

const Button = React.forwardRef(function Button(
  props: Omit<Props, 'variant'> & {
    variant?: 'text' | 'outlined' | 'contained'
  },
  ref: React.ForwardedRef<HTMLButtonElement | null>,
) {
  return <MuiButton {...props} ref={ref} />
})

export const IconButton = React.forwardRef(function IconButton(
  props: IconProps,
  ref: React.ForwardedRef<HTMLButtonElement | null>,
) {
  return <MuiIconButton {...props} ref={ref} />
})

export const LoadingButton = React.forwardRef(function LoadingButton(
  props: Omit<Props, 'variant'> & {
    loading?: boolean
    loadingPosition?: 'center' | 'start' | 'end' | undefined
    variant?: 'text' | 'outlined' | 'contained'
  },
  ref: React.ForwardedRef<HTMLButtonElement | null>,
) {
  return <MuiLoadingButton {...props} ref={ref} />
})

export const BackButton = ({ fallback }: { fallback: string }) => {
  const history = useHistory()
  const canGoBack = useSelector((state) => state.application.canGoBack)
  const previousLocation = useSelector(
    (state) => state.application.previousLocation,
  )

  return (
    <Button
      to={canGoBack ? previousLocation ?? fallback : fallback}
      onClickCapture={(e) => {
        if (canGoBack) {
          e.preventDefault()
          e.stopPropagation()
          history.back()
        }
      }}
    >
      Back
    </Button>
  )
}

export default Button
